import React from "react";
import styled from "styled-components";
import { CTATarget } from "./getCTAData";
import HeroFilerCta from "./HeroFilerCta";

export const BankruptcyHeroCTA = (props: {
  onClickAskUpsolveAIButton?: () => void;
  trackingPageContext: any;
  ctaTarget: CTATarget;
}): React.ReactElement => {
  return (
    <CTAContainer>
      {/* hero filer cta being generic sort of breaks this abstraction, but we should be able to break out of it at some point */}
      <HeroFilerCta
        trackingPageContext={props.trackingPageContext}
        target={props.ctaTarget}
        dataTestId="inline-content-cta-mobile"
      />
    </CTAContainer>
  );
};

export const BankruptcyMobileCTA = (props: {
  onClickAskUpsolveAIButton?: () => void;
  trackingPageContext: any;
  ctaTarget: CTATarget;
}) => {
  return (
    <CTAContainer>
      <HeroFilerCta
        trackingPageContext={props.trackingPageContext}
        target={props.ctaTarget}
        dataTestId="inline-content-cta-mobile"
      />
    </CTAContainer>
  );
};

const CTAContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
